import axios from "axios";
import React, { useEffect, useState } from "react";
import { serverUrl } from "../../../Constant/Static/config";
const civil = require("../../../Constant/Json/civil.json");
const mechanical = require("../../../Constant/Json/mechanical.json");
const electrical = require("../../../Constant/Json/electrical.json");
const electronics = require("../../../Constant/Json/electronics.json");
const computer = require("../../../Constant/Json/computer.json");
const chemical = require("../../../Constant/Json/chemical.json");
const textile = require("../../../Constant/Json/textile.json");
const leather = require("../../../Constant/Json/leather.json");
const printing = require("../../../Constant/Json/printing.json");
const modern_office = require("../../../Constant/Json/modernoffice.json");
const bsc = require("../../../Constant/Json/bsc.json");
const miscellaneous = require("../../../Constant/Json/miscellaneous.json");
const departments = {
  1: "Civil",
  2: "Mechanical",
  3: "Electrical",
  4: "Electronics",
  5: "Computer",
  6: "Chemical",
  7: "Textile",
  8: "Leather",
  9: "Printing",
  10: "Modern Office",
  11: "BSC",
  12: "MISCELLANEOUS",
};

function ApplicationStatus() {
  const [appNo, setAppNo] = useState("");
  const [csrfToken, setCsrfToken] = useState("");
  const [response, setResponse] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [avg, setavg] = useState(0);
  const [preSum, setPresum] = useState(0);
  const [finalSum, setFinalsum] = useState(0);
  const obt_total = 0;
  const max_total = 0;


  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true,
        });
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };
    fetchCsrfToken();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!appNo || !csrfToken) {
      setError("Application number and CSRF token are required");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${serverUrl}/api/admin/application-status`,
        { appNo},
        {
          headers: {
            "Content-Type": "application/json",
            "CSRF-Token": csrfToken,
          },
        }
      );
      // console.log(result);
      // console.log("MAX_1:", res.data.result[0].MAX_1);
      // console.log("MAX_2:", res.data.result[0].MAX_2);
      // console.log("MAX_3:", res.data.result[0].MAX_3);
      // console.log("MAX_4:", res.data.result[0].MAX_4);
      // console.log("MAX_5:", res.data.result[0].MAX_5);
      // console.log("MAX_6:", res.data.result[0].MAX_6);
      // console.log("MAX_7:", res.data.result[0].MAX_7);
      // console.log("MAX_8:", res.data.result[0].MAX_8);
      const result = res.data.result[0] || {};

      const pre_obt = [
        result.OBT_1, result.OBT_2, result.OBT_3, result.OBT_4, result.OBT_5, result.OBT_6
      ].reduce((sum, val) => sum + (Number(val) || 0), 0);

      const pre_max = [
        result.MAX_1, result.MAX_2, result.MAX_3, result.MAX_4, result.MAX_5, result.MAX_6
      ].reduce((sum, val) => sum + (Number(val) || 0), 0);


      const final_obt = [
        result.OBT_7, result.OBT_8
      ].reduce((sum, val) => sum + (Number(val) || 0), 0);

      const final_max = [
        result.MAX_7, result.MAX_8
      ].reduce((sum, val) => sum + (Number(val) || 0), 0);

      const pre_percent = pre_max > 0 ? (pre_obt / pre_max) * 100 : 0;
      const final_percent = final_max > 0 ? (final_obt / final_max) * 100 : 0;


      const obt_total = pre_obt + final_obt;
      const max_total = pre_max + final_max;
      const avg = max_total > 0 ? (obt_total / max_total) * 100 : 0;


      setavg(avg);
      setPresum(pre_percent);
      setFinalsum(final_percent);


      // console.log("Pre-sem %:", pre_percent);
      // console.log("Final-sem %:", final_percent);
      // console.log("Overall %:", avg);


      // console.log("Pre-sem Obtained:", pre_obt);
      // console.log("Final-sem Obtained:", final_obt);
      // console.log("Total Obtained:", obt_total);
      // console.log("Total Max:", max_total);
      // console.log("Average %:", avg);

      // console.log("Average:", avg);
      setResponse(res.data.result || []);
      // console.log(res.data.result);


      setError(null);
    } catch (err) {
      setError("Error fetching application status");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };





  const getBranchName = (groupStudied, branchStudied) => {
    // console.log(groupStudied)
    // console.log(branchStudied)

    const id = String(branchStudied);

    switch (groupStudied) {
      case '1':
        return civil.find((item) => item.id === id)?.name || "-";
      case '2':
        return mechanical.find((item) => item.id === id)?.name || "-";
      case '3':
        return electrical.find((item) => item.id === id)?.name || "-";
      case '4': {

        return electronics.find((item) => item.id === id)?.name || "-";
      }
      case '5':
        return computer.find((item) => item.id === id)?.name || "-";
      case '6':
        return chemical.find((item) => item.id === id)?.name || "-";
      case '7':
        return textile.find((item) => item.id === id)?.name || "-";
      case '8':
        return leather.find((item) => item.id === id)?.name || "-";
      case '9':
        return printing.find((item) => item.id === id)?.name || "-";
      case '10':
        return modern_office.find((item) => item.id === id)?.name || "-";
      case '11':
        return bsc.find((item) => item.id === id)?.name || "-";
      case '12':
        return miscellaneous.find((item) => item.id === id)?.name || "-";
      default:
        return "-";
    }
  };

  const getStudyDetailText = (studyDetail) => {
    switch (studyDetail) {
      case 1:
        return "9th Standard";
      case 2:
        return "10th Standard";
      case 3:
        return "11th Standard";
      case 4:
        return "12th Standard";
      case 5:
        return "Diploma 1st Year";
      case 6:
        return "Diploma 2nd Year";
      case 7:
        return "Diploma 3rd Year";
      case 8:
        return "Diploma 4th Year";
      case 9:
        return "BSc 1st Year";
      case 10:
        return "BSc 2nd Year";
      case 11:
        return "BSc 3rd Year";
      case 12:
        return "ITI";
      default:
        return "-";
    }
  };

  const getCommunityText = (community) => {
    switch (community) {
      case "1":
        return "ST";
      case "2":
      case "3":
        return "SC";
      case "4":
        return "MBC";
      case "5":
        return "BC";
      case "6":
        return "BCM";
      case "7":
        return "OC";
      default:
        return "-";
    }
  };

  const styles = {
    appServiceContainer: {
      flex: "1 1 250px",
      margin: "0 16px",
      padding: "10px",
      position: "relative",
      border: "2px solid #cce6ff",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
      minWidth: "250px",
      maxWidth: "calc(100% - 4vw)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#f0f7ff",
      boxSizing: "border-box",
      overflowY: "auto",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      fontFamily: "'Roboto', Arial, sans-serif",
      boxSizing: "border-box",
      width: "100%",
      maxWidth: "100%",
      margin: "20px 0",
      overflowX: "auto",
    },
    title: {
      color: "#003087",
      fontSize: "1.5rem",
      fontWeight: 500,
      marginBottom: "20px",
    },
    form: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      width: "100%",
      maxWidth: "500px",
      boxSizing: "border-box",
      transition: "transform 0.3s ease",
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: "20px",
      width: "100%",
    },
    label: {
      fontSize: "1rem",
      color: "#002060",
      marginBottom: "5px",
    },
    input: {
      padding: "10px",
      width: "100%",
      maxWidth: "300px",
      border: "2px solid #cce6ff",
      borderRadius: "5px",
      fontSize: "16px",
      outline: "none",
      transition: "border-color 0.3s ease, box-shadow 0.3s ease",
      boxSizing: "border-box",
    },
    inputFocus: {
      borderColor: "#003087",
      boxShadow: "0px 0px 5px rgba(0, 48, 135, 0.5)",
    },
    button: {
      padding: "10px 20px",
      color: "#ffffff",
      backgroundColor: "#003087",
      border: "none",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s ease, transform 0.2s ease",
    },
    buttonHover: {
      backgroundColor: "#002060",
      transform: "scale(1.05)",
    },
    buttonDisabled: {
      backgroundColor: "#cccccc",
      cursor: "not-allowed",
    },
    error: {
      color: "red",
      textAlign: "center",
      margin: "10px 0",
    },
    loading: {
      color: "#002060",
      textAlign: "center",
      margin: "10px 0",
    },
    preview: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "15px",
      padding: "20px",
      width: "100%",
      maxWidth: "100%",
      margin: "20px 0",
      borderRadius: "8px",
      border: "2px solid #cce6ff",
      backgroundColor: "#ffffff",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      boxSizing: "border-box",
    },
    previewPart: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "10px",
    },
    previewText: {
      margin: "5px 0",
      padding: "10px",
      fontSize: "1rem",
      color: "#002060",
      transition: "background-color 0.3s ease",
    },
    previewTextHover: {
      backgroundColor: "#f9fcff",
    },
    tableContainer: {
      width: "100%",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
      borderRadius: "8px",
      overflow: "hidden",
      boxSizing: "border-box",
      margin: "20px 0",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff",
      tableLayout: "fixed",
    },
    th: {
      backgroundColor: "#003087",
      color: "#ffffff",
      fontWeight: 600,
      textAlign: "center",
      padding: "14px",
      border: "1px solid #99ccff",
      whiteSpace: "normal",
      wordBreak: "break-word",
      position: "sticky",
      top: 0,
      zIndex: 1,
    },
    td: {
      padding: "14px",
      textAlign: "center",
      border: "1px solid #99ccff",
      color: "#002060",
      whiteSpace: "normal",
      wordBreak: "break-word",
      minWidth: "120px",
    },
    trEven: {
      backgroundColor: "#f9fcff",
    },
    trOdd: {
      backgroundColor: "#ffffff",
    },
    trHover: {
      backgroundColor: "#e6f3ff",
    },
  };


  const isSmallScreen = window.innerWidth < 600;
  if (isSmallScreen) {
    styles.preview.gridTemplateColumns = "1fr";
    styles.previewPart.gridTemplateColumns = "1fr";
    styles.table.tableLayout = "auto";
    styles.th.minWidth = "80px";
    styles.td.minWidth = "80px";
  }

  return (
    // <div style={styles.appServiceContainer}>
    <div style={styles.container}>
      <h2 style={styles.title}>Application Status</h2>
      <form
        onSubmit={handleSubmit}
        style={styles.form}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        <div style={styles.formGroup}>
          <label htmlFor="appNo" style={styles.label}>
            Application No:
          </label>
          <input
            type="text"
            id="appNo"
            value={appNo}
            onChange={(e) => setAppNo(e.target.value)}
            required
            style={styles.input}
            onFocus={(e) => Object.assign(e.currentTarget.style, styles.inputFocus)}
            onBlur={(e) =>
              Object.assign(e.currentTarget.style, { borderColor: "#cce6ff", boxShadow: "none" })
            }
          />
        </div>
        <button
          type="submit"
          style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button}
          onMouseEnter={(e) => !loading && Object.assign(e.currentTarget.style, styles.buttonHover)}
          onMouseLeave={(e) =>
            !loading &&
            Object.assign(e.currentTarget.style, {
              backgroundColor: "#003087",
              transform: "scale(1)",
            })
          }
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>

      {error && <p style={styles.error}>{error}</p>}
      {loading && <p style={styles.loading}>Loading...</p>}

      {response.map((data, index) => (
        <div key={index}>

          <div style={styles.preview}>
            <div style={styles.previewPart}>
              <div>
                <p style={styles.previewText}>Name of the Applicant:</p>
                <p style={styles.previewText}>Email ID:</p>
                <p style={styles.previewText}>Name of the Parent/Guardian:</p>
                <p style={styles.previewText}>Date of Birth:</p>
                <p style={styles.previewText}>Nativity:</p>
              </div>
              <div>
                <p style={styles.previewText}>{data.APPLICANT_NAME || "-"}</p>
                <p style={styles.previewText}>{data.EMAIL || "-"}</p>
                <p style={styles.previewText}>{data.PARENT_NAME || "-"}</p>
                <p style={styles.previewText}>{data.DOB || "-"}</p>
                <p style={styles.previewText}>{data.NATIVITY || "-"}</p>
              </div>
            </div>
            <div style={styles.previewPart}>
              <div>
                <p style={styles.previewText}>Community:</p>
                <p style={styles.previewText}>Contact Number:</p>
                <p style={styles.previewText}>Gender:</p>
                <p style={styles.previewText}>Citizenship:</p>
                <p style={styles.previewText}>Religion:</p>
                <p style={styles.previewText}>Caste:</p>
              </div>
              <div>
                <p style={styles.previewText}>{data.COMMUNITY || '-'}</p>
                <p style={styles.previewText}>{data.MOBILE || "-"}</p>
                <p style={styles.previewText}>
                  {data.SEX || "-"}
                </p>
                <p style={styles.previewText}>{data.CITIZENSHIP || "-"}</p>
                <p style={styles.previewText}>
                  {data.RELIGION === "H"
                    ? "Hindu"
                    : data.RELIGION === "M"
                      ? "Muslim"
                      : data.RELIGION === "C"
                        ? "Christian"
                        : data.RELIGION === "O"
                          ? "Others"
                          : "-"}
                </p>
                <p style={styles.previewText}>{data.CASTE || "-"}</p>
              </div>
            </div>
          </div>


          <div style={styles.preview}>
            <div style={styles.previewPart}>

              <div>
                <p style={styles.previewText}>Permanent Address:</p>
                <p style={styles.previewText}>Street:</p>
                <p style={styles.previewText}>City/Village:</p>
                <p style={styles.previewText}>Taluk:</p>
                <p style={styles.previewText}>District:</p>
                <p style={styles.previewText}>Pincode:</p>
              </div>
              <div>
                <p style={styles.previewText}>{data.PERMANENT_ADDRESS?.address || "-"}</p>
                <p style={styles.previewText}>{data.PERMANENT_ADDRESS?.street || "-"}</p>
                <p style={styles.previewText}>{data.PERMANENT_ADDRESS?.village || "-"}</p>
                <p style={styles.previewText}>{data.PERMANENT_ADDRESS?.taluk || "-"}</p>
                <p style={styles.previewText}>{data.PERMANENT_ADDRESS?.district || "-"}</p>
                <p style={styles.previewText}>{data.PERMANENT_ADDRESS?.pin || "-"}</p>
              </div>
            </div>
            <div style={styles.previewPart}>
              <div>
                <p style={styles.previewText}>Communication Address:</p>
                <p style={styles.previewText}>Street:</p>
                <p style={styles.previewText}>City/Village:</p>
                <p style={styles.previewText}>Taluk:</p>
                <p style={styles.previewText}>District:</p>
                <p style={styles.previewText}>Pincode:</p>
              </div>
              <div>
                <p style={styles.previewText}>{data.COMMUNICATION_ADDRESS?.address || "-"}</p>
                <p style={styles.previewText}>{data.COMMUNICATION_ADDRESS?.street || "-"}</p>
                <p style={styles.previewText}>{data.COMMUNICATION_ADDRESS?.village || "-"}</p>
                <p style={styles.previewText}>{data.COMMUNICATION_ADDRESS?.taluk || "-"}</p>
                <p style={styles.previewText}>{data.COMMUNICATION_ADDRESS?.district || "-"}</p>
                <p style={styles.previewText}>{data.COMMUNICATION_ADDRESS?.pin || "-"}</p>
              </div>
            </div>
          </div>

          {/* Special Categories */}
          <div style={styles.preview}>
            <div style={styles.previewPart}>
              <div>
                <p style={styles.previewText}>Differently Abled:</p>
                <p style={styles.previewText}>Eminent Sports Person:</p>
                <p style={styles.previewText}>Children of Exserviceman:</p>
              </div>
              <div>
                <p style={styles.previewText}>{data.SPECIAL_DA === "N" ? "No" : data.SPECIAL_DA === "Y" ? "Yes" : "-"}</p>
                <p style={styles.previewText}>{data.SPECIAL_SP === "N" ? "No" : data.SPECIAL_SP === "Y" ? "Yes" : "-"}</p>
                <p style={styles.previewText}>{data.SPECIAL_ESM === "N" ? "No" : data.SPECIAL_ESM === "Y" ? "Yes" : "-"}</p>
              </div>
            </div>
            <div style={styles.previewPart}>
              <div>
                <p style={styles.previewText}>Srilankan Tamil Refugee:</p>
                <p style={styles.previewText}>First Graduate:</p>
              </div>
              <div>
                <p style={styles.previewText}>{data.SRILANKAN_REFUGEE === "Y" ? "Yes" : data.SRILANKAN_REFUGEE === "N" ? "No" : "-"}</p>
                <p style={styles.previewText}>{data.FIRST_GRADUATE === "Y" ? "Yes" : data.FIRST_GRADUATE === "N" ? "No" : "-"}</p>
              </div>
            </div>
          </div>


          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>SLNO</th>
                  <th style={styles.th}>Study Details</th>
                  <th style={styles.th}>Year of Passing</th>
                  <th style={styles.th}>School/College</th>
                  <th style={styles.th}>District</th>
                  <th style={styles.th}>State</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    study: data.STUDY_DETAIL_1?.study_detail,
                    year: data.STUDY_DETAIL_1?.year,
                    school: data.STUDY_DETAIL_1?.school,
                    address: data.STUDY_DETAIL_1?.district,
                    state: data.STUDY_DETAIL_1?.state,
                  },
                  {
                    study: data.STUDY_DETAIL_2?.study_detail,
                    year: data.STUDY_DETAIL_2?.year,
                    school: data.STUDY_DETAIL_2?.school,
                    address: data.STUDY_DETAIL_2?.district,
                    state: data.STUDY_DETAIL_2?.state,
                  },
                  {
                    study: data.STUDY_DETAIL_3?.study_detail,
                    year: data.STUDY_DETAIL_3?.year,
                    school: data.STUDY_DETAIL_3?.school,
                    address: data.STUDY_DETAIL_3?.district,
                    state: data.STUDY_DETAIL_3?.state,
                  },
                  {
                    study: data.STUDY_DETAIL_4?.study_detail,
                    year: data.STUDY_DETAIL_4?.year,
                    school: data.STUDY_DETAIL_4?.school,
                    address: data.STUDY_DETAIL_4?.district,
                    state: data.STUDY_DETAIL_4?.state,
                  },
                  {
                    study: data.STUDY_DETAIL_5?.study_detail,
                    year: data.STUDY_DETAIL_5?.year,
                    school: data.STUDY_DETAIL_5?.school,
                    address: data.STUDY_DETAIL_5?.district,
                    state: data.STUDY_DETAIL_5?.state,
                  },
                ].map((row, idx) => (
                  <tr
                    key={idx}
                    style={idx % 2 === 0 ? styles.trEven : styles.trOdd}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e6f3ff")}
                    onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      idx % 2 === 0 ? "#f9fcff" : "#ffffff")
                    }
                  >
                    <td style={styles.td}>{idx + 1}</td>
                    <td style={styles.td}>{row.study}</td>
                    <td style={styles.td}>{row.year || "-"}</td>
                    <td style={styles.td}>{row.school || "-"}</td>
                    <td style={styles.td}>{row.address || "-"}</td>
                    <td style={styles.td}>{row.state || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>


          <div style={styles.preview}>
            <div style={styles.previewPart}>
              <div>
                <p style={styles.previewText}>Group Name:</p>
                <p style={styles.previewText}>Name of Polytechnic College:</p>
                <p style={styles.previewText}>Board of the Polytechnic College:</p>
              </div>
              <div>
                <p style={styles.previewText}>{departments[data.GROUP_STUDIED] || "-"}</p>
                <p style={styles.previewText}>{data.COLLAGE_NAME || "-"}</p>
                <p style={styles.previewText}>{data.COLLAGE_BOARD || "-"}</p>
              </div>
            </div>
            <div style={styles.previewPart}>
              <div>
                <p style={styles.previewText}>Branch Name:</p>
                <p style={styles.previewText}>Address of Polytechnic College:</p>
                <p style={styles.previewText}>Diploma/BSc Examination Register Number:</p>
              </div>
              <div>
                <p style={styles.previewText}>{getBranchName(data.GROUP_STUDIED, data.BRANCH_STUDIED)}</p>
                <p style={styles.previewText}>{data.COLLAGE_ADDRESS || "-"}</p>
                <p style={styles.previewText}>{data.univ_reg_no || "-"}</p>
              </div>
            </div>
          </div>

          {/* Semester Details Table */}
          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Semester</th>
                  <th style={styles.th}>Month & Year of Passing</th>
                  <th style={styles.th}>Marks Obtained</th>
                  <th style={styles.th}>Maximum Marks</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { sem: 1, monthYear: data.PASSING_MON_YEAR_1, obt: data.OBT_1, max: data.MAX_1 },
                  { sem: 2, monthYear: data.PASSING_MON_YEAR_2, obt: data.OBT_2, max: data.MAX_2 },
                  { sem: 3, monthYear: data.PASSING_MON_YEAR_3, obt: data.OBT_3, max: data.MAX_3 },
                  { sem: 4, monthYear: data.PASSING_MON_YEAR_4, obt: data.OBT_4, max: data.MAX_4 },
                  { sem: 5, monthYear: data.PASSING_MON_YEAR_5, obt: data.OBT_5, max: data.MAX_5 },
                  { sem: 6, monthYear: data.PASSING_MON_YEAR_6, obt: data.OBT_6, max: data.MAX_6 },
                  { sem: 7, monthYear: data.PASSING_MON_YEAR_7, obt: data.OBT_7, max: data.MAX_7 },
                  { sem: 8, monthYear: data.PASSING_MON_YEAR_8, obt: data.OBT_8, max: data.MAX_8 },
                ].map((row, idx) => (
                  <tr
                    key={idx}
                    style={idx % 2 === 0 ? styles.trEven : styles.trOdd}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e6f3ff")}
                    onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      idx % 2 === 0 ? "#f9fcff" : "#ffffff")
                    }
                  >
                    <td style={styles.td}>Semester {row.sem}</td>
                    <td style={styles.td}>{row.monthYear || "-"}</td>
                    <td style={styles.td}>{row.obt || "-"}</td>
                    <td style={styles.td}>{row.max || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>


          <div style={styles.preview}>
            <div style={styles.previewPart}>
              <div>

                <p style={styles.previewText}>Average:</p>
              </div>
              <div>

                <p style={styles.previewText}>{avg}</p>

              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

  );
}

export default ApplicationStatus;